import { defineStore } from 'pinia'
import { useJackpotStore } from '~/stores/'
import type { LiveJackpot, GameItem, GoBigWin } from '~/types'

const gameInfo = {
    vgmn_100: {
        name: 'TÀI XỈU',
        initAmount: 20_000_000_000,
        partner_provider: 'go',
        partner_game_id: 'vgmn_100',
        partner: 'go',
        partner_txt: 'Go88',
        api_url: '/gameUrl?p=go&gId=vgmn_100',
        maintain: false,
        deny_info: false,
        is_new: false,
        is_favorite: false,
    },
    vgcg_9: {
        name: 'XÓC ĐĨA',
        initAmount: 20_000_000_000,
        partner_provider: 'go',
        partner_game_id: 'vgcg_9',
        partner: 'go',
        partner_txt: 'Go88',
        api_url: '/gameUrl?p=go&gId=vgcg_9',
        maintain: false,
        deny_info: false,
        is_new: false,
        is_favorite: false,
    },
    vgmn_109: {
        name: 'XÓC ĐĨA LIVE',
        initAmount: 10_000_000_000,
        partner: 'go',
        partner_txt: 'Go88',
        partner_provider: 'go',
        partner_game_id: 'vgmn_109',
        partner_game_type: 'sexy,xocdia',
        api_url:
            '/casinoUrl?p=go&gId=vgmn_109&gt=sexy,xocdia&tId=qs_xocdia-102',
        table_id: 'qs_xocdia-102',
        deny_info: false,
        maintain: false,
        is_new: false,
        is_favorite: false,
    },
    'qs_txgo-101': {
        name: 'TÀI XỈU LIVE',
        initAmount: 5_000_000_000,
        partner: 'go',
        partner_txt: 'Go88',
        partner_provider: 'go',
        partner_game_id: 'qs_txgo-101',
        partner_game_type: 'sicbo,sexy',
        api_url:
            '/casinoUrl?p=go&gId=qs_txgo-101&gt=sicbo,sexy&tId=qs_txgo-101',
        table_id: 'qs_txgo-101',
        deny_info: false,
        maintain: false,
        is_new: false,
        is_favorite: false,
    },
    vgcg_14: {
        name: 'BẦU CUA',
        initAmount: 3_000_000_000,
        partner: 'go',
        partner_txt: 'Go88',
        partner_provider: 'go',
        partner_game_id: 'vgcg_14',
        api_url: '/gameUrl?p=go&gId=vgcg_14',
        maintain: false,
        deny_info: false,
        is_new: false,
        is_favorite: false,
    },
    vgmn_221: {
        name: 'AVIATOR',
        initAmount: 1_500_000_000,
        partner_provider: 'go',
        partner_game_id: 'vgmn_221',
        partner: 'go',
        partner_txt: 'Go88',
        api_url: '/gameUrl?p=go&gId=vgmn_221',
        maintain: false,
        deny_info: false,
        is_new: false,
        is_favorite: false,
    },
} as Record<string, GameItem>

export const useGamesGoStore = defineStore('gamesJackpot', () => {
    const useJackpotStoreInstance = useJackpotStore()
    const { jackpots } = storeToRefs(useJackpotStoreInstance)

    const gamesGo = ref<
        Array<GameItem & { amount: number; initAmount: number; on: boolean }>
    >([])

    const bigWin = ref<GoBigWin>()

    const bannerGo = computed(() =>
        gamesGo.value.filter(
            (game) => game.amount >= game.initAmount && game.on
        )
    )

    const totalJackpot = computed(() => {
        return gamesGo.value.reduce(
            (total: number, game) => total + (game?.amount || 0),
            0
        )
    })

    /**
     * Synchronizes the active game information ("game on") from the API or socket.
     *
     * @param dataApi - The game data from the API or socket, can be undefined.
     * @param options - An object containing parameters, e.g., `isSocket` to determine whether the data is from a socket or API.
     * @returns A list of active games, including information such as id, name, initAmount, and amount.
     */
    const syncGameOn = (
        dataApi: Record<string, LiveJackpot> | undefined = undefined,
        { isSocket } = { isSocket: false }
    ) => {
        // Default list of games
        let gamesList = [
            'vgmn_100',
            'vgcg_9',
            'vgcg_14',
            'vgmn_109',
            'qs_txgo-101',
            'vgmn_221',
        ]

        if (dataApi) {
            // console.log('dataApi', dataApi)
            gamesList = gamesList.filter((item) => {
                // const name = isSocket ? item : `go_${item}` // Use `go_` prefix if not socket data
                const name = `go_${item}` // Use `go_` prefix if not socket data

                return dataApi[name]
            })
        }

        // console.log('gamesList', gamesList)

        const result = gamesList.map((item) => {
            // const name = isSocket ? item : `go_${item}`
            const name = `go_${item}`

            return {
                ...gameInfo[item],
                id: item,
                name: gameInfo[item]?.name,
                initAmount: gameInfo[item]?.initAmount,
                amount: dataApi?.[name] ?? jackpots?.[name] ?? 0,
                on: gameInfo[item]?.on,
            }
        })

        gamesGo.value = result

        return result
    }

    /**
     * Updates the big win information.
     *
     * @param data - The big win data to update, can be undefined.
     */
    const updateBigWin = (data?: GoBigWin) => {
        if (!data) return

        bigWin.value = data
    }

    return {
        gamesGo,
        bannerGo,
        syncGameOn,
        updateBigWin,
        bigWin,
        totalJackpot,
    }
})
